import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Spin } from 'antd'
import '../../styles/_index.scss'
import moment from 'moment'

class GarmentQuantityStatisticsTable extends Component {

    render() {
        const { loading, batches, total, totalWithTimeSlot, newFilter, totalBatchesWithoutMoved } = this.props

        const timeOptions = [
            '8h-9h', '9h-10h', '10h-11h',
            '11h-12h', '12h-13h', '13h-14h',
            '14h-15h', '15h-16h', '16h-17h',
            '17h-18h', '18h-19h', '19h-20h',
            '20h-21h', 'Ngoài 8h-21h'
        ]

        const checkPeriod = (value) => {
            const currentTime = moment()
            if (newFilter.mark_sewed_date === currentTime.format('YYYY-MM-DD')) {
                if (value.includes('Ngoài')) {
                    const [startTime, endTime] = value.split('-');
                    if (!currentTime.isBetween(moment(startTime, 'HH'), moment(endTime, 'HH'))) return 'PeriodSelect'
                } else {
                    const [startTime, endTime] = value.split('-');
                    if (currentTime.isBetween(moment(startTime, 'HH'), moment(endTime, 'HH'))) return 'PeriodSelect'
                }
            }
        }

        return (
            <Spin spinning={loading} tip='Đang tải...'>
                <table className='table table-bordered table-striped GarmentQuantityStatisticsTable' id='ExportTable'>
                    <thead className='thead-light'>

                        <tr>
                            <th className='text-center' rowSpan={2} style={{ background: '#1b4332', color: 'white' }}>
                                <p>PARTNER MAY - NHÓM MAY</p>
                            </th>
                            <th className="text-center" rowSpan={2} style={{ background: '#1b4332', color: 'white' }}>
                                <p>ĐANG MAY</p>
                            </th>
                            <th className="text-center" rowSpan={2} style={{ background: '#1b4332', color: 'white' }}>
                                <p>TỔNG</p>
                            </th>
                            <th className="text-center" colSpan={14} style={{ background: '#1b4332', color: 'white' }}> THỜI GIAN</th>
                        </tr>
                        <tr>
                            {!!timeOptions.length && timeOptions.map((i, index) => (
                                <th key={index} className={`text-center ${checkPeriod(i)}`} style={{ background: '#52b788', color: 'white' }}>{i}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {!!batches && batches.length > 0 &&
                            <tr>
                                <td className='font-weight-bold text-center'></td>
                                <td className='font-weight-bold text-center'>{totalBatchesWithoutMoved || '-'}</td>
                                <td className='font-weight-bold text-center'>{total || '-'}</td>
                                {!!timeOptions.length && timeOptions.map((i, index) => (
                                    <td key={index} className={`text-center font-weight-bold ${checkPeriod(i)}`}>{!!totalWithTimeSlot ? totalWithTimeSlot[i] || '-' : '-'}</td>
                                ))}
                            </tr>
                        }
                        {
                            !!batches && batches.length > 0 ? (
                                batches.map((item, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{item.sewing_partner_info.name || '-'}</td>
                                        <td className='text-center'>{item.total_item_without_moved || '-'}</td>
                                        <td className='font-weight-bold text-center'>{item.total || '-'}</td>
                                        {!!timeOptions.length && timeOptions.map((i, index) => (
                                            <td key={index} className={`text-center ${checkPeriod(i)}`}>
                                                {
                                                    item.time_slot && Object.keys(item.time_slot).length > 0 && item.time_slot[i] ? item.time_slot[i] : '-'
                                                }
                                            </td>
                                        ))}
                                    </tr>
                                )
                                )

                            ) : (
                                <tr>
                                    <td colSpan={26}>No data</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </Spin>
        )
    }
}

GarmentQuantityStatisticsTable.propTypes = {
    batches: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    onChangeProductType: PropTypes.func
}

export default GarmentQuantityStatisticsTable
